import React from 'react'
import { type IconProps } from '../IconPropsInterface'

export const DashboardHeart: React.FC<IconProps> = ({ color = '#126554' }) => (
  <svg
    width="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8368 9.43297L9.00648 15L3.17617 9.43297C2.7916 9.07219 2.48869 8.63855 2.2865 8.15935C2.08431 7.68016 1.98722 7.1658 2.00135 6.64865C2.01548 6.13151 2.14052 5.62279 2.3686 5.15452C2.59667 4.68626 2.92285 4.26859 3.32658 3.92783C3.73031 3.58707 4.20285 3.33059 4.71444 3.17454C5.22604 3.0185 5.76561 2.96627 6.29917 3.02114C6.83273 3.07602 7.34873 3.2368 7.81466 3.49338C8.2806 3.74996 8.68639 4.09677 9.00648 4.51198C9.32795 4.09979 9.73421 3.75601 10.1998 3.50215C10.6654 3.24829 11.1804 3.08983 11.7125 3.03667C12.2445 2.98351 12.7823 3.0368 13.292 3.19321C13.8017 3.34962 14.2724 3.60578 14.6747 3.94565C15.0771 4.28553 15.4023 4.70181 15.63 5.16843C15.8578 5.63505 15.9832 6.14198 15.9984 6.65748C16.0136 7.17298 15.9183 7.68596 15.7184 8.16431C15.5186 8.64266 15.2184 9.07609 14.8368 9.43747"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
